export const translations = {
  en: {
    nav: {
      services: "How I help",
      how: "How it works",
      coverage: "Where",
      faq: "Questions",
      book: "Message on WhatsApp",
    },
    hero: {
      eyebrow: "Riyadh",
      titleLine1: "Need a hand",
      titleLine2: "around the house?",
      subtitle:
        "Hi — I'm around Al Muruj, Hittin, Al Yasmin, Al Malqa & nearby. When your usual electrician is busy or the plumber isn't answering, just send me a WhatsApp and we'll figure it out together.",
      cta_primary: "Message on WhatsApp",
      cta_secondary: "See how I help",
      legacy: "Honoring the 25-year legacy of Talib Hussain",
      legacy_label: "Est. Riyadh",
    },
    services: {
      eyebrow: "Electrician + Plumber help",
      title: "Around the house.",
      subtitle:
        "If any of these are giving you trouble, send me a message with a photo — we'll take it from there.",
      electrical: {
        name: "Electrician",
        tagline: "An electrician, when you need one.",
        items: [
          "A socket that stopped working",
          "A switch or light fitting to swap",
          "A ceiling light or fan hanging loose",
          "A tripping breaker to look at",
        ],
      },
      plumbing: {
        name: "Plumber",
        tagline: "A plumber, when yours won't answer.",
        items: [
          "A leaking tap or connection",
          "A slow drain or blockage",
          "A running toilet",
          "A shower or mixer to swap",
        ],
      },
    },
    how: {
      eyebrow: "How it works",
      title: "Three steps.",
      steps: [
        {
          n: "01",
          t: "Send a WhatsApp",
          d: "Message me with what's bothering you. A photo or short video helps a lot.",
        },
        {
          n: "02",
          t: "We chat",
          d: "We talk about what it might be and when I can drop by.",
        },
        {
          n: "03",
          t: "We sort it",
          d: "I come by, take a look, and we sort it out together.",
        },
      ],
    },
    coverage: {
      eyebrow: "Where",
      title: "Around Al Muruj & nearby.",
      subtitle:
        "I'm usually around Al Muruj and the neighbourhoods next to it. If you're a little further, still send a message — we can talk about it.",
      areas: [
        "Al Muruj",
        "Hittin",
        "Al Yasmin",
        "Al Malqa",
        "Al Nada",
        "An Nakheel",
        "Ar Rabi",
        "Al Ghadeer",
        "Al Maseef",
        "Al Muhammadiyah",
        "Al Sahafa",
        "King Fahd District",
      ],
      soon: "A little further? Just ask",
    },
    faq: {
      eyebrow: "Questions",
      title: "A few common ones.",
      items: [
        {
          q: "How do I reach you?",
          a: "Just send a WhatsApp message. A photo or short video of the issue helps a lot.",
        },
        {
          q: "How soon can you come?",
          a: "If I'm around Al Muruj that day, usually the same day. If not, we'll pick a time together.",
        },
        {
          q: "What if you can't fix it?",
          a: "No worries — if it's outside what I can help with, I'll let you know honestly. No pressure.",
        },
        {
          q: "Which areas?",
          a: "Mostly Al Muruj and the neighbourhoods around it. If you're further, just message — we can talk about it.",
        },
      ],
    },
    footer: {
      tagline: "Around Al Muruj, Riyadh.",
      contact: "Say hi",
      quick: "On this page",
      hours: "Usually around",
      hours_val: "Most days · afternoons & evenings",
      rights: "",
    },
    whatsapp: {
      msg_default: "Hi Talibnaz, I'd like to enquire about your services.",
      cta_label: "Say hi on WhatsApp",
    },
  },
  ar: {
    nav: {
      services: "كيف أساعد",
      how: "كيف يعمل",
      coverage: "أين",
      faq: "أسئلة",
      book: "راسلني على واتساب",
    },
    hero: {
      eyebrow: "الرياض",
      titleLine1: "تحتاج مساعدة",
      titleLine2: "في البيت؟",
      subtitle:
        "السلام عليكم — أنا في المروج وحطين والياسمين والملقا وما حولها. لما الكهربائي مشغول أو السباك ما يرد، أرسل لي رسالة واتساب ونحلها سوا.",
      cta_primary: "راسلني على واتساب",
      cta_secondary: "شوف كيف أساعد",
      legacy: "تكريماً لإرث 25 عاماً من طالب حسين",
      legacy_label: "الرياض",
    },
    services: {
      eyebrow: "كهربائي وسباك",
      title: "في البيت.",
      subtitle:
        "إذا في شيء من هذي يزعجك، أرسل لي رسالة مع صورة ونتفاهم.",
      electrical: {
        name: "كهربائي",
        tagline: "كهربائي، لما تحتاجه.",
        items: [
          "مقبس توقف يشتغل",
          "مفتاح أو إنارة نبي نبدلها",
          "لمبة سقف أو مروحة راكيبها",
          "قاطع يفصل بستمرار",
        ],
      },
      plumbing: {
        name: "سباك",
        tagline: "سباك، لما سباكك ما يرد.",
        items: [
          "صنبور أو وصلة تسرب",
          "صرف بطيء أو مسدود",
          "سيفون يجري باستمرار",
          "دش أو خلاط نبي نغيره",
        ],
      },
    },
    how: {
      eyebrow: "كيف يعمل",
      title: "ثلاث خطوات.",
      steps: [
        {
          n: "٠١",
          t: "أرسل رسالة واتساب",
          d: "راسلني بالمشكلة. صورة أو فيديو قصير يساعد كثير.",
        },
        {
          n: "٠٢",
          t: "نتكلم",
          d: "نتفاهم شو ممكن يكون المشكلة ومتى أقدر أمر عليك.",
        },
        {
          n: "٠٣",
          t: "نحل الأمر",
          d: "أمر أشوف الوضع، ونتفاهم على الحل سوا.",
        },
      ],
    },
    coverage: {
      eyebrow: "أين",
      title: "حول المروج والأحياء القريبة.",
      subtitle:
        "أنا عادة في حي المروج والأحياء اللي جنبه. إذا أنت أبعد شوي، برضو راسلني — نتفاهم.",
      areas: [
        "المروج",
        "حطين",
        "الياسمين",
        "الملقا",
        "الندى",
        "النخيل",
        "الربيع",
        "الغدير",
        "المصيف",
        "المحمدية",
        "الصحافة",
        "حي الملك فهد",
      ],
      soon: "أبعد شوي؟ راسلني",
    },
    faq: {
      eyebrow: "أسئلة",
      title: "أسئلة شائعة.",
      items: [
        {
          q: "كيف أتواصل معك؟",
          a: "أرسل رسالة واتساب. صورة أو فيديو قصير للمشكلة يساعد كثير.",
        },
        {
          q: "متى ممكن تجي؟",
          a: "إذا كنت في المروج ذلك اليوم، عادة نفس اليوم. غير كذا، نتفق على وقت مناسب.",
        },
        {
          q: "إذا ما قدرت تحل المشكلة؟",
          a: "لا تشغل بالك — إذا الأمر خارج قدرتي، أخبرك بصراحة. بدون أي ضغط.",
        },
        {
          q: "أي أحياء؟",
          a: "أكثر شي المروج والأحياء اللي حواليه. إذا أنت أبعد، راسلني ونتفاهم.",
        },
      ],
    },
    footer: {
      tagline: "حول المروج، الرياض.",
      contact: "تواصل",
      quick: "في هذي الصفحة",
      hours: "متى موجود",
      hours_val: "معظم الأيام · بعد الظهر والمساء",
      rights: "",
    },
    whatsapp: {
      msg_default: "السلام عليكم طالبناز، أرغب في الاستفسار عن خدماتكم.",
      cta_label: "سلم على واتساب",
    },
  },
};
